import { ConfigTab } from './config-tab';

export class SetActiveConfigTab {
  static readonly type = '[ConfigState] SetActiveConfigTab';
  constructor(public readonly tab: ConfigTab) {}
}
